import { FC } from 'react';
import { useIsMobile } from '../../../../utils/getIsMobile';
import { CarouselIndicators } from '../../../carousel/CarouselIndicators';
import { Box } from '../../../layout/Box';
import { DataTestId } from '../../../layout/DataTestIdWrapper';
import { PostCardProps, renderStatusBadge } from '../../PostCard/PostCard';
import { usePostDetailsCardContext } from '../PostDetailsCard';
import { SoundContainer } from '../styles';

interface PostHeaderProps {
    post: PostCardProps['post'];
    onStatusBadgeClick: PostCardProps['onStatusBadgeClick'];
}

export const PostHeader: FC<PostHeaderProps> = ({ post, onStatusBadgeClick }) => {
    const { activeIndex, sizes, setSoundControlContainer } = usePostDetailsCardContext();
    const soundControlContainerEnabled = post.content[activeIndex]?.type === 'video';
    const isMobile = useIsMobile();

    return (
        <Box
            position="absolute"
            top={0}
            left={0}
            width={sizes.width}
            height={sizes.height}
            maxWidth={{ sm: '100%' }}
        >
            {isMobile ? (
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    width="100%"
                    zIndex={5}
                    px={1.5}
                    py={3 / 4}
                >
                    <CarouselIndicators
                        variant="story"
                        activeIndex={activeIndex}
                        count={post.content.length}
                    />
                </Box>
            ) : null}

            {renderStatusBadge(post, onStatusBadgeClick)}
            {soundControlContainerEnabled ? (
                <SoundContainer
                    isMobile={Boolean(isMobile)}
                    right={1.5}
                    dataTestId={DataTestId.MUTE}
                    ref={(element) => {
                        setSoundControlContainer(element);
                    }}
                />
            ) : null}
        </Box>
    );
};
